export default class BPTrinkgeldRequest {
  bestellungId: string
  type: string
  trinkgeld: number
}
